import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { render_date } from 'utils';
import { FormattedMessage } from 'ui/i18n';

import { LeftSideCategory, DownloadLink } from 'ui/components';

@inject('UIState')
@observer
export default class SidebarItem extends Component {
	static propTypes = {
		promo: PropTypes.object.isRequired,
		UIState: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);
		this.props.UIState.savePromotion({
			id: this.props.promo.id,
			expand: this.expand.bind(this),
		});
	}

	componentWillReceiveProps(props) {
		this.props.UIState.savePromotion({
			id: props.promo.id,
			expand: this.expand.bind(this),
		});
	}

	@observable expanded = false;

	@action
	toggle() {
		this.expanded = !this.expanded;
	}

	@action
	expand(expand) {
		this.expanded = expand;
	}

	render() {
		const { promo } = this.props;
		const expanded = this.expanded ? 'expanded' : '';

		const start_date = (
			<span>
				<FormattedMessage id="itemsTable.startDateColumn" />{' '}
				{render_date(promo.start_date)}
			</span>
		);

		return (
			<div
				id={`SidebarItemId-${promo.id}`}
				className={`SidebarItem ${expanded}`}
			>
				<div className="SidebarItem__header" onClick={this.toggle.bind(this)}>
					<div className="SidebarItem__header__title">
						{promo.is_preview
							? <span>
									<FormattedMessage id="leftSideMenu.previewText" />{' '}
									{promo.name}
								</span>
							: promo.name}
						<span className="SidebarItem__header__title__icon" />
					</div>
					<div className="SidebarItem__header__subtitle">
						{promo.is_preview &&
							<p>
								{start_date}
							</p>}
						<p>
							<FormattedMessage id="itemsTable.endDateColumn" />{' '}
							{render_date(promo.end_date)}
						</p>
					</div>
				</div>
				<div className="SidebarItem__content">
					<DownloadLink
						name={promo.name}
						promotionId={promo.id}
						className="SidebarItem__download"
					/>
					{promo.categories.map(category =>
						<LeftSideCategory
							key={category.id}
							category={category}
							promo_end_date={promo.end_date}
							promotionId={promo.id}
						/>
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Sidebar/SidebarItem/index.js